module.exports = __webpack_public_path__ + "static/media/Station2.2d12512e.png";